import { http } from '../../config/axios'

export default function postCampanha(campanha: any): Promise<string> {
  return http
    .post('api/campanha', campanha)
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro post campanha', error)
      throw Error(error.response.data)
    })
}
